import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const stateApi = createApi({
  reducerPath: 'states',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getStates: builder.query({
      query: ({ currentPage = 1, resultPerPage = 100 } = {}) => ({
        url: `/api/state`,
        method: 'GET',
        params: {
          current_page: currentPage,
          result_per_page: resultPerPage,
        },
      }),
    }),
    updateState: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/api/state/${id}`,
          method: 'PUT',
          body: body,
        };
      },
    }),
    createState: builder.mutation({
      query: body => ({
        url: `/api/state`,
        method: 'POST',
        body: body,
      }),
    }),
    deleteState: builder.mutation({
      query: ({ id }) => {
        return {
          url: `api/state/${id}`,
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useCreateStateMutation,
  useUpdateStateMutation,
  useGetStatesQuery,
  useLazyGetStatesQuery,
  useDeleteStateMutation,
} = stateApi;
